export default __webpack_public_path__ + "static/media/logo.0b14c150.jpg";